(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    root.querySelectorAll('[data-b-hrev]').forEach(function (wrap) {
      if (wrap.dataset.bInit) return;
      wrap.dataset.bInit = '1';
      var track = wrap.querySelector('[data-b-hrev-track]');
      var dots = wrap.querySelectorAll('[data-b-hrev-dot]');
      if (!track || !dots.length) return;
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          var i = parseInt(d.getAttribute('data-b-hrev-dot'), 10);
          track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
        });
      });
      track.addEventListener('scroll', function () {
        var i = Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
        dots.forEach(function (d, n) { if (n === i) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current'); });
      }, { passive: true });
    });
  }
  init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b-pdp-v2"]) return;
  try {
    
(function(){
  document.querySelectorAll('.b-p2__gal').forEach(function(g){
    var row=g.querySelector('.b-p2__thumbs'); if(!row) return;
    var track=g.querySelector('[data-b-gal-track]');
    var down=false,moved=false,sx=0,sl=0;
    row.addEventListener('pointerdown',function(e){ if(e.pointerType!=='mouse') return; down=true;moved=false;sx=e.clientX;sl=row.scrollLeft; });
    window.addEventListener('pointermove',function(e){ if(!down) return; var dx=e.clientX-sx; if(Math.abs(dx)>5){moved=true;row.classList.add('is-dragging');} if(moved) row.scrollLeft=sl-dx; });
    window.addEventListener('pointerup',function(){ if(!down) return; down=false; row.classList.remove('is-dragging'); });
    row.addEventListener('click',function(e){ if(moved){e.stopPropagation();e.preventDefault();moved=false;} },true);
    function follow(){
      var a=row.querySelector('[aria-current="true"]'); if(!a) return;
      var l=a.offsetLeft, r=l+a.offsetWidth;
      if(l<row.scrollLeft) row.scrollTo({left:l-parseInt(getComputedStyle(row).paddingLeft||0,10),behavior:'smooth'});
      else if(r>row.scrollLeft+row.clientWidth) row.scrollTo({left:r-row.clientWidth+parseInt(getComputedStyle(row).paddingRight||0,10),behavior:'smooth'});
    }
    var t; if(track) track.addEventListener('scroll',function(){ clearTimeout(t); t=setTimeout(follow,120); },{passive:true});
  });
})();
(function(){
  function pad(n){return (n<10?'0':'')+n}
  document.querySelectorAll('[data-p2-countdown]').forEach(function(el){
    var raw=el.getAttribute('data-p2-countdown').trim().replace(' ','T');
    var end=new Date(raw).getTime();
    if(isNaN(end)) return;
    function tick(){
      var d=end-Date.now();
      if(d<=0){el.hidden=true;clearInterval(t);return}
      el.hidden=false;
      var s=Math.floor(d/1000);
      el.querySelector('[data-d]').textContent=pad(Math.floor(s/86400));
      el.querySelector('[data-h]').textContent=pad(Math.floor(s%86400/3600));
      el.querySelector('[data-m]').textContent=pad(Math.floor(s%3600/60));
      el.querySelector('[data-s]').textContent=pad(s%60);
    }
    var t=setInterval(tick,1000);tick();
  });
  document.addEventListener('change',function(e){
    var scope=e.target.closest('[data-b-product]');if(!scope)return;
    var tot=scope.querySelector('[data-p2-total]');if(!tot)return;
    var vs=JSON.parse(scope.querySelector('[data-b-variants]').textContent);
    var idi=scope.querySelector('form[data-b-add] input[name="id"]');
    var v=vs.find(function(x){return String(x.id)===String(idi&&idi.value)});if(!v)return;
    var money=scope.getAttribute('data-b-money')||'${{amount}}';
    function fmt(c){return money.replace(/\{\{\s*amount\s*\}\}/,(c/100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,','))}
    var base=(v.compare_at_price&&v.compare_at_price>v.price)?v.compare_at_price:v.price;
    var was=base+parseInt(tot.getAttribute('data-gifts')||'0',10);
    var w=tot.querySelector('[data-t-was]'),n=tot.querySelector('[data-t-now]'),sv=tot.querySelector('[data-t-save]');
    n.textContent=fmt(v.price);
    var sale=was>v.price;w.hidden=!sale;sv.hidden=!sale;
    if(sale){w.textContent=fmt(was);sv.textContent='Save '+Math.round((was-v.price)*100/was)+'%';}
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b-reviews"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.bDragInit){window.bDragInit(document);return;}
  function bind(el){
    if(el.dataset.dragInit) return; el.dataset.dragInit='1';
    var down=false,moved=false,sx=0,sl=0;
    function items(){return Array.prototype.filter.call(el.children,function(c){return c.offsetWidth>0})}
    function snap(dir){
      var base=el.getBoundingClientRect().left+(parseFloat(getComputedStyle(el).paddingLeft)||0);
      var best=el.scrollLeft,bd=1e9;
      items().forEach(function(c){
        var off=c.getBoundingClientRect().left-base+el.scrollLeft;
        var ahead=(dir>0&&off>el.scrollLeft+1)||(dir<0&&off<el.scrollLeft-1);var d=Math.abs(off-el.scrollLeft)-(ahead?40:0);
        if(d<bd){bd=d;best=off}
      });
      el.scrollTo({left:Math.max(0,Math.min(best,el.scrollWidth-el.clientWidth)),behavior:'smooth'});
    }
    el.addEventListener('pointerdown',function(e){
      if(e.pointerType==='touch'||e.button!==0||el.scrollWidth<=el.clientWidth+1) return;
      if(e.target.closest('video[controls]')) return;
      down=true;moved=false;sx=e.clientX;sl=el.scrollLeft;
    });
    window.addEventListener('pointermove',function(e){
      if(!down) return;
      var dx=e.clientX-sx;
      if(!moved&&Math.abs(dx)>6){moved=true;el.classList.add('is-dragging');}
      if(moved){el.scrollLeft=sl-dx;e.preventDefault();}
    });
    window.addEventListener('pointerup',function(e){
      if(!down) return; down=false;
      if(moved){
        var dir=e.clientX<sx?1:-1;
        el.classList.remove('is-dragging');
        el._noClick=true; setTimeout(function(){el._noClick=false},80);
        snap(dir);
      }
    });
    el.addEventListener('click',function(e){if(el._noClick){e.preventDefault();e.stopPropagation();}},true);
    el.addEventListener('dragstart',function(e){e.preventDefault()});
  }
  window.bDragInit=function(root){(root||document).querySelectorAll('[data-b-drag]').forEach(bind)};
  window.bDragInit(document);
  document.addEventListener('shopify:section:load',function(e){window.bDragInit(e.target)});
})();
(function(){
  function init(root){
    root.querySelectorAll('.b-rev__wrap').forEach(function(w){
      if(w.dataset.revInit) return; w.dataset.revInit='1';
      var t=w.querySelector('[data-rev-track]'),p=w.querySelector('[data-rev-prev]'),n=w.querySelector('[data-rev-next]');
      if(!t) return;
      function step(){var c=t.querySelector('.b-rev__card');return c?c.getBoundingClientRect().width+24:300}
      function upd(){var none=t.scrollWidth<=t.clientWidth+2;if(p){p.disabled=t.scrollLeft<=2;p.hidden=none}if(n){n.disabled=t.scrollLeft+t.clientWidth>=t.scrollWidth-2;n.hidden=none}}
      if(p)p.addEventListener('click',function(){t.scrollBy({left:-step(),behavior:'smooth'})});
      if(n)n.addEventListener('click',function(){t.scrollBy({left:step(),behavior:'smooth'})});
      t.addEventListener('scroll',upd,{passive:true});window.addEventListener('resize',upd);upd();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b-videos"] && !Shopify.designMode) return;
  try {
    
(function(){
  if(window.bDragInit){window.bDragInit(document);return;}
  function bind(el){
    if(el.dataset.dragInit) return; el.dataset.dragInit='1';
    var down=false,moved=false,sx=0,sl=0;
    function items(){return Array.prototype.filter.call(el.children,function(c){return c.offsetWidth>0})}
    function snap(dir){
      var base=el.getBoundingClientRect().left+(parseFloat(getComputedStyle(el).paddingLeft)||0);
      var best=el.scrollLeft,bd=1e9;
      items().forEach(function(c){
        var off=c.getBoundingClientRect().left-base+el.scrollLeft;
        var ahead=(dir>0&&off>el.scrollLeft+1)||(dir<0&&off<el.scrollLeft-1);var d=Math.abs(off-el.scrollLeft)-(ahead?40:0);
        if(d<bd){bd=d;best=off}
      });
      el.scrollTo({left:Math.max(0,Math.min(best,el.scrollWidth-el.clientWidth)),behavior:'smooth'});
    }
    el.addEventListener('pointerdown',function(e){
      if(e.pointerType==='touch'||e.button!==0||el.scrollWidth<=el.clientWidth+1) return;
      if(e.target.closest('video[controls]')) return;
      down=true;moved=false;sx=e.clientX;sl=el.scrollLeft;
    });
    window.addEventListener('pointermove',function(e){
      if(!down) return;
      var dx=e.clientX-sx;
      if(!moved&&Math.abs(dx)>6){moved=true;el.classList.add('is-dragging');}
      if(moved){el.scrollLeft=sl-dx;e.preventDefault();}
    });
    window.addEventListener('pointerup',function(e){
      if(!down) return; down=false;
      if(moved){
        var dir=e.clientX<sx?1:-1;
        el.classList.remove('is-dragging');
        el._noClick=true; setTimeout(function(){el._noClick=false},80);
        snap(dir);
      }
    });
    el.addEventListener('click',function(e){if(el._noClick){e.preventDefault();e.stopPropagation();}},true);
    el.addEventListener('dragstart',function(e){e.preventDefault()});
  }
  window.bDragInit=function(root){(root||document).querySelectorAll('[data-b-drag]').forEach(bind)};
  window.bDragInit(document);
  document.addEventListener('shopify:section:load',function(e){window.bDragInit(e.target)});
})();
(function(){
  function init(root){
    (root||document).querySelectorAll('.b-vids__wrap').forEach(function(w){
      if(w.dataset.vInit) return; w.dataset.vInit='1';
      var t=w.querySelector('[data-vids-track]'),p=w.querySelector('.b-vids__nav--prev'),n=w.querySelector('.b-vids__nav--next');
      if(!t) return;
      function upd(){var none=t.scrollWidth<=t.clientWidth+2;if(p){p.disabled=t.scrollLeft<=2;p.hidden=none}if(n){n.disabled=t.scrollLeft+t.clientWidth>=t.scrollWidth-2;n.hidden=none}}
      t.addEventListener('scroll',upd,{passive:true});window.addEventListener('resize',upd);upd();
    });
  }
  init(document);
  document.addEventListener('shopify:section:load',function(e){init(e.target)});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
